import $ from 'jquery'
import Cookies from 'js-cookie'

import modals from '../../support/modals'
import { trackInternalEvent } from '@rio/tracking'

class CookiePanel {
  constructor($panel, cookieController) {
    this.$panel = $panel
    this.cookieController = cookieController
    this.$acceptButton = this.$panel.find('.cookie-panel__accept')
    this.$rejectButton = this.$panel.find('.cookie-panel__reject')
    this.$acceptEssentialButton = this.$panel.find('.cookie-panel__accept-essential')
    this.$settingsButton = this.$panel.find('.cookie-panel__settings')
    this.$footerPrivacyChoices = $('#privacy-options-toggle')

    const openOnStartup = this.$panel.data('open-on_startup')
    openOnStartup && this.open()

    this.$acceptButton.click(this.handleAcceptAllCookies)
    this.$rejectButton.click(this.handleRejectAllCookies)
    this.$settingsButton.click(this.handleSettingsClick)
    this.$acceptEssentialButton.click(this.handleAcceptEssentialCookies)

    this.$footerPrivacyChoices.on('click', this.handleFooterPrivacyChoices)
  }

  handleAcceptAllCookies = () => {
    if (this.cookieController) {
      this.cookieController.acceptAllCookies()
    }

    trackInternalEvent('click_cookie_banner', {
      cta_text: 'Accept all',
      cookie_settings: 'Accept all',
    })

    this.close()
  }

  handleAcceptEssentialCookies = () => {
    if (this.cookieController) {
      this.cookieController.acceptEssentialCookies()
    }

    trackInternalEvent('click_cookie_banner', {
      cta_text: 'Essential only',
      cookie_settings: 'Essential only',
    })

    this.close()
  }

  handleRejectAllCookies = () => {
    if (this.cookieController) {
      this.cookieController.rejectAllCookies()
    }

    trackInternalEvent('click_cookie_banner', {
      cta_text: 'Reject all',
      cookie_settings: 'Reject',
    })

    this.close()
  }

  handleSettingsClick = () => {
    trackInternalEvent('open_cookie_banner_settings')

    modals.cookieSettingsModal.open()
  }

  handleFooterPrivacyChoices = () => {
    trackInternalEvent('open_footer_privacy_choices')

    // Check if the panel is already open. if not open do nothing
    const panelOpenAlready = this.$panel.hasClass('is-open')
    if (!panelOpenAlready) modals.cookieSettingsModal.open()
  }

  open = () => {
    this.$panel.addClass('is-open')
  }

  close = () => {
    this.$panel.removeClass('is-open')
    this.setUserPrivacySettings()
  }

  setUserPrivacySettings = () => {
    const cookies = Cookies.getJSON('cookie_consent')

    const allowData = cookies.find(item => item === 'AllowDataUsage')
    const status = allowData ? 'granted' : 'denied'

    fetch('/api/app/account/pi-sharing', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status }),
    }).catch(() => {
      // prevent logging in console for non logged in users
    })
  }
}

export default CookiePanel
